export default {"src":"/_next/static/media/ic-vk.6663e637.svg","height":32,"width":31};